export function createNewPathForLocationSlug(href: string, locationSlug: string): string {
    const url = new URL(href)
    url.searchParams.delete("umkreis")
    url.searchParams.delete("page")
    url.searchParams.delete("adresse")

    const hashParams = new URLSearchParams(url.hash.substring(1))
    hashParams.delete("coins-modal")
    url.hash = hashParams.toString()

    let urlParts = url.pathname.split("/")

    if (urlParts[1] === "sex-anzeigen") {
        // /sex-anzeigen/...
        urlParts.unshift(locationSlug)
    } else if (urlParts[2] === "sex-anzeigen" || urlParts[1]) {
        // /berlin/sex-anzeigen/.. or /standort/sex-anzeigen/...
        // /frankfurt-main
        urlParts[1] = locationSlug
    } else {
        // /...
        urlParts.unshift(locationSlug, "sex-anzeigen")
    }

    urlParts = urlParts.filter((part) => part !== "")

    url.pathname = urlParts.join("/")
    return url.href
}

export function updateUrl(url: string) {
    window.history.pushState({}, "", url)
}

export function generateBannerDateApiUrl(url: string): string {
    if (SiteInfo.bannerDate === null) {
        return url
    }

    if (url.indexOf("?") >= 0) {
        return url.concat("&bannerDate=" + SiteInfo.bannerDate)
    }

    return url.concat("?bannerDate=" + SiteInfo.bannerDate)
}
